import React, { useState} from "react";
import "./settings.css";
import Navbar from "../MainComponent/navbar";
import SideNav from "../MainComponent/sideNav";
import Alert from "react-bootstrap/Alert";
import Loader from "../MainComponent/loader";

export default function Setting() {
  const [show, setShow] = useState(false);
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [email] = useState("");
  const [newPassword, setNewPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false);
  const [address, setAddress] = useState("");
  const [logo, setLogo] = useState("");
  const [loader] = useState(false);

  function handleFileUpload(e) {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMegabytes = file.size / (1024 * 1024); // Convert bytes to megabytes
      if (fileSizeInMegabytes <= 1) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          setLogo(reader.result);
        };
      } else {
        alert("File size exceeds 1MB. Please choose a smaller file.");
        e.target.value = ""; // Clear the file input
      }
    }
  }

  return (
    <>
      {loader && <Loader backgroundColor={"#000000cf"}></Loader>}
      <div className="settingContainer">
        <Navbar />

        <div className="settingContent">
          <SideNav active="settings" />
          <div className="settingInfo">
            <h1>Account Settings</h1>
            <span className="u-line"></span>
            <div className="infoForm">
              <div className="formWithLabel">
                <label>Full Name</label>
                <input
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                ></input>
              </div>
              <div className="formWithLabel">
                <label>Company Name</label>
                <input
                  type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                ></input>
              </div>
              <div className="formWithLabel">
                <label>Company Logo</label>
                <div className="uploadLogo">
                  <input
                    className="fileInput"
                    type="file"
                    aria-labelledby="Choose Logo"
                    accept="image/*"
                    onChange={(e) => handleFileUpload(e)}
                  />
                  <img src={logo} alt="companyLogo" />
                </div>
              </div>
              <div className="formWithLabel">
                <label>Address</label>
                <input
                  type="text"
                  placeholder="Enter your address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
              <div className="formWithLabel">
                <label>Phone Number</label>
                <div className="phoneBox">
                  <span>+92</span>
                  <input
                    type="number"
                    value={phoneNo}
                    onChange={(e) => setPhoneNo(e.target.value)}
                  ></input>
                </div>
              </div>
              <div className="formWithLabel">
                <label>Email Address</label>
                <input
                  type="email"
                  value={email}
                  disabled
                  style={{ backgroundColor: "#E9ECEF" }}
                ></input>
              </div>
              <div className="formWithLabel">
                <label>Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                ></input>
                <i
                  className={
                    showPassword ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"
                  }
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </div>
              {show && (
                <Alert
                  variant="success"
                  onClose={() => setShow(false)}
                  dismissible
                  className="popupMessage"
                >
                  Changes Saved as Successfully!
                </Alert>
              )}
              <button className="settingButton" 
              // onClick={handleSaves}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
